<script setup lang="ts">

import { useGameStore } from '@/stores/gameStore.ts'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { computed } from 'vue'
import Type3SmallModel from '@/components/Interface/Modal/ModelSizes/Type3/Type3SmallModel.vue'
import { tutorialSteps } from './tutorialSteps'
import TutorialGameFinished from './Steps/TutorialGameFinished.vue'


const gameStore = useGameStore()
const playerFlagsStore = usePlayerFlagsStore()

const currentStepId = computed(() => {
  return playerFlagsStore.getFlag('tutorial_current_step') ?? 'tutorial_intro'
})

const currentStep = computed(() => {
  return tutorialSteps.find(step => step.id === currentStepId.value) ?? tutorialSteps[0]
})

const shouldShowTutorial = computed(() => {
  // Don't show tutorial if it's completed, disabled, or if websocket hasn't synced
  return gameStore.websocketInitialSyncCompleted === true &&
         playerFlagsStore.getFlag('tutorial_complete') !== 'true' &&
         playerFlagsStore.getFlag('tutorial_disable_tutorial') !== 'true'
})

const shouldShowGameFinished = computed(() => {
  return gameStore.websocketInitialSyncCompleted === true && gameStore.gameFinished === true
})

const modalTitle = computed(() => {
  return shouldShowGameFinished.value ? 'Game Complete' : currentStep.value.title
})

const modalComponent = computed(() => {
  return shouldShowGameFinished.value ? TutorialGameFinished : currentStep.value.component
})

</script>

<template>
  <Type3SmallModel
    v-if="shouldShowTutorial || shouldShowGameFinished"
    :title="modalTitle"
    :use-minimize-animation="true"
    minimize-flag-key="tutorial_hidden"
  >
    <component :is="modalComponent" />
  </Type3SmallModel>
</template>

<style scoped lang="scss">

</style>